import catalog from './catalog.json';

export const KIND_STATES = {
  tab: ['visible', 'hidden'],
  section: ['visible', 'hidden'],
  col: ['visible', 'hidden'],
  badge: ['visible', 'hidden'],
  btn: ['visible', 'disabled', 'hidden'],
  action: ['visible', 'disabled', 'hidden'],
  field: ['editable', 'readonly', 'hidden'],
};

export const STATE_RANK = { visible: 2, editable: 2, disabled: 1, readonly: 1, hidden: 0 };

export const kindOf = (key) => {
  const kind = String(key).split('.')[1];
  return KIND_STATES[kind] ? kind : null;
};

export const mostPermissive = (key) => {
  const kind = kindOf(key);
  return kind ? KIND_STATES[kind][0] : 'visible';
};

export const CATALOG_PATHS = catalog.pages.map((p) => p.path);

const normalise = (path) => {
  const clean = String(path || '').split('?')[0].split('#')[0];
  return clean.replace(/\/+$/, '') || '/';
};

// Catalog page that owns `path`: the longest whole-segment prefix. "/" only matches itself.
export const matchRoute = (path, knownPaths) => {
  const target = normalise(path);
  let best = null;
  for (const routePath of knownPaths) {
    if (routePath === '*') continue;
    const candidate = normalise(routePath);
    const hit = target === candidate || (candidate !== '/' && target.startsWith(`${candidate}/`));
    if (hit && (best === null || candidate.length > normalise(best).length)) best = routePath;
  }
  return best;
};

const ELEMENT_FILES = Object.fromEntries(catalog.elements.map((e) => [e.key, e.files || []]));

const SCREEN_ORDER = ['List page', 'Detail page', 'Create page'];

const screenOf = (file) => {
  const base = file.split('/').pop().replace(/\.(jsx?|tsx?)$/, '');
  if (file.startsWith('pages/')) {
    if (/Detail|Terminal/.test(base)) return 'Detail page';
    if (/^New|Create/.test(base)) return 'Create page';
    return 'List page';
  }
  return base.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
};

const screenRank = (screen) => {
  const i = SCREEN_ORDER.indexOf(screen);
  return i === -1 ? SCREEN_ORDER.length : i;
};

export const screensOf = (key) => [...new Set((ELEMENT_FILES[key] || []).map(screenOf))]
  .sort((a, b) => screenRank(a) - screenRank(b) || a.localeCompare(b));

export const groupByScreen = (elements) => {
  const groups = new Map();
  for (const el of elements) {
    const screens = screensOf(el.key);
    const id = screens.join('|');
    if (!groups.has(id)) groups.set(id, { screens, elements: [] });
    groups.get(id).elements.push(el);
  }
  return [...groups.values()].sort((a, b) => {
    const ra = a.screens.length ? Math.min(...a.screens.map(screenRank)) : 99;
    const rb = b.screens.length ? Math.min(...b.screens.map(screenRank)) : 99;
    return ra - rb || a.screens.length - b.screens.length || a.screens.join().localeCompare(b.screens.join());
  });
};

export const DEFAULT_HOME = '/products';

// URL to open for a home page; the catalog's "/" is the product catalogue, which lives at /products.
export const homeUrl = (home) => (!home || home === '/' ? DEFAULT_HOME : home);

export const PREVIEW_FRAME_NAME = 'avacore-access-preview';
export const PREVIEW_MESSAGE = 'avacore-access-preview';
export const PREVIEW_READY_MESSAGE = 'avacore-access-preview-ready';

export const isAccessPreviewFrame = () => {
  try {
    return window.self !== window.top && window.name === PREVIEW_FRAME_NAME;
  } catch (error) {
    return false;
  }
};
